import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosBaseURL from "../../common/apis/axiosBaseURL";
import { authHeader } from "../../common/apis/authHeader";
import HandleError from "../../common/apis/HandleError";
import { apiVersion } from "../../common/apis/apiVersion";

export const PaymentGatewayAction = createAsyncThunk(
    "payment/PaymentGatewayAction",
    async (values) => {
        try {
            const response = await axiosBaseURL.post("/app/"+apiVersion.v1+"/payment/verifyOrder", values, {
                headers: authHeader()
            });
            return response.data;
        } catch (error) {
            HandleError(error.response.data)
            return error.response.data
        }
    }
);

const initialState = {
    payment: {}
};

const PaymentSlice = createSlice({
    name: "payment",
    initialState,
    reducers: {},
    extraReducers: {
        [PaymentGatewayAction.pending]: (state) => {
            return { ...state, loading: true };
        },
        [PaymentGatewayAction.fulfilled]: (state, { payload }) => {
            return { ...state, payment: payload, loading: false };
        },
        [PaymentGatewayAction.rejected]: (state) => {
            return { ...state, loading: false };
        }
    }
})

// export const { RemoveProfileStoreData, ResetPlayerDetails, ResetCityList } = PaymentSlice.actions;
export const getPaymentData = (state) => state.payment.payment;
export default PaymentSlice.reducer;
